;(() => {
    // ==== DEBUG ====
    let DEBUG = true;
    const NS = '[PlisseeCfg]';
    const log  = (...a) => DEBUG && console.log(NS, ...a);
    const warn = (...a) => DEBUG && console.warn(NS, ...a);

    // ==== Robuste Selektoren ====
    // Enthält-Suche statt Suffix: deckt "abcd,...,option_rahmenfarbe" sicher ab
    const SEL_RAHMEN = 'input[type="radio"][name*="Rahmenfarbe"]';
    // Stoff-"Dropdown" ist readonly-Textinput; match auf Namensfragment + Klasse als Fallback
    const SEL_STOFF  = 'input[name*="Stoffauswahl"], input.tpo_option-input.tpo_option-dropdown[readonly]';

    // ==== Hilfen ====
    const slug = (s) => s?.toString().trim().toLowerCase()
        .replace(/ä/g,'ae').replace(/ö/g,'oe').replace(/ü/g,'ue').replace(/ß/g,'ss')
        .normalize('NFKD').replace(/[\u0300-\u036f]/g,'')
        .replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'') || '';

    const widths = [246,493,600,713,823,990,1100,1206,1346,1426,1646,1946];
    const stripWidthParam = (url) => url.replace(/([?&])width=\d+(&|$)/, (m,p1,p2) => p2 ? p1 : '');
    const withWidth = (base, w) => {
        const u = stripWidthParam(base);
        return u + (u.includes('?') ? '&' : '?') + 'width=' + w;
    };
    const buildSrcset = (base) => widths.map(w => `${withWidth(base, w)} ${w}w`).join(', ');

    const ALT_TEXT = 'Classic-Plissee Verdunkelnd nach Maß';
    const getHero = () => {
        let el = document.querySelector('[data-hero-img]');
        if (el) return el;
        el = document.querySelector(`img[alt="${ALT_TEXT}"]`);
        if (el) el.setAttribute('data-hero-img','');
        return el;
    };

    const getRahmenfarbe = () => {
        const viaGroup = document.querySelector(`${SEL_RAHMEN}:checked`);
        const viaId    = document.querySelector('input[id^="option_rahmenfarbe-"]:is(.tpo_checked, :checked)');
        return (viaGroup || viaId)?.value || '';
    };
    const getStoff = () => {
        const input = document.querySelector(SEL_STOFF);
        let v = input?.value || '';
        return v.replace(/\s*\*$/, '').trim();
    };

    // vorhandene Breiten aus einem srcset extrahieren (z. B. "246w, 493w, ...")
    const parseWidths = (srcset) => {
        if (!srcset) return [];
        return Array.from(srcset.matchAll(/(\d+)\s*w/g)).map(m => parseInt(m[1], 10));
    };

    const rebuildForImg = (img, baseUrl) => {
        const widths = parseWidths(img.getAttribute('srcset'));
        const fallback = widths.length ? Math.max(...widths) : 3000;
        img.src = withWidth(baseUrl, fallback);
        if (widths.length) {
            img.srcset = widths.map(w => `${withWidth(baseUrl, w)} ${w}w`).join(', ');
        } else {
            // kein srcset vorhanden → kleinses Default-Set
            img.srcset = [400, 800, 1200].map(w => `${withWidth(baseUrl, w)} ${w}w`).join(', ');
        }
    };

    const rebuildForPicture = (img, baseUrl) => {
        const pic = img.closest('picture');
        if (!pic) return;
        pic.querySelectorAll('source').forEach(src => {
            const widths = parseWidths(src.getAttribute('srcset'));
            if (!widths.length) return;
            src.srcset = widths.map(w => `${withWidth(baseUrl, w)} ${w}w`).join(', ');
        });
    };

    // alle Gallery-Bilder (Hero + Thumbs) updaten
    const updateGalleryImages = (baseUrl) => {
        const imgs = Array.from(document.querySelectorAll(`img[alt="${ALT_TEXT}"]`));
        imgs.forEach(img => {
            rebuildForImg(img, baseUrl);
            rebuildForPicture(img, baseUrl);
            // Hero etwas „fetter“ behandeln
            if (img.hasAttribute('data-hero-img')) {
            img.sizes = "(min-width: 1024px) 800px, 90vw";
            img.decoding = "async";
            img.loading  = "eager";
            img.fetchPriority = "high";
            }
        });
    };

    // Map laden
    const imageMapEl = document.getElementById('plissee-image-map');
    if (!imageMapEl) { warn('image-map <script> nicht gefunden'); return; }
    let imageMap = {};
    try { imageMap = JSON.parse(imageMapEl.textContent); }
    catch (e) { warn('Fehler beim Parsen der image-map', e); return; }

    // ==== Bild-Update (throttled) ====
    let raf, pending = false;
    const scheduleUpdate = () => {
        if (pending) return;
        pending = true;
        setTimeout(() => { pending = false; updateHero(); }, 0);
    };

    const updateHero = () => {
        const hero = getHero();
        if (!hero) { warn('Hero-Image nicht gefunden'); return; }
        var stoff  = getStoff();
        if (stoff == "") {
            stoff = imageMap["default-stoff"];
        }
        const stoffWithOutPlus = stoff.split(" +")[0];
        var rahmen = getRahmenfarbe();
        if (rahmen == "") {
            rahmen = imageMap["default-rahmen"];
        }
        const key    = `${slug(stoffWithOutPlus)}|${slug(rahmen)}`;
        const baseUrl = imageMap[key];
        log('updateHero', { stoffWithOutPlus, rahmen, key, hit: !!baseUrl });
        if (!baseUrl) return;

        const pre = new Image();
        pre.decoding = 'async';
        pre.src = withWidth(baseUrl, 1100);

        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
            updateGalleryImages(baseUrl);   // <— neu: alle passenden Bilder updaten
            log('gallery aktualisiert');
        });
    };

    // ==== Warten bis die Inputs da sind (einmalig, dann disconnect) ====
    const waitForInputs = (cb) => {
        const found = () => {
        const r = document.querySelector(SEL_RAHMEN);
        const s = document.querySelector(SEL_STOFF);
        log('scan inputs', { rahmen: !!r, stoff: !!s });
        return r && s;
        };
        if (found()) return cb();

        const mo = new MutationObserver(() => {
        if (found()) {
            mo.disconnect();
            cb();
        }
        });
        mo.observe(document.documentElement, { childList: true, subtree: true });
        // Sicherheits-Timeout, damit wir nicht ewig horchen
        setTimeout(() => mo.disconnect(), 15000);
    };

    // ==== Listener binden, wenn Elemente vorhanden ====
    const bindOnce = () => {
        // Delegierte Events (fangen Re-Renders mit ab)
        document.addEventListener('change', (e) => {
        if (e.target.matches(SEL_RAHMEN) || e.target.matches(SEL_STOFF)) {
            log('EVENT change', { name: e.target.name, value: e.target.value });
            scheduleUpdate();
        }
        }, { passive: true });

        document.addEventListener('input', (e) => {
        if (e.target.matches(SEL_STOFF)) {
            log('EVENT input', { name: e.target.name, value: e.target.value });
            scheduleUpdate();
        }
        }, { passive: true });

        // Click-Fallback im Capture-Modus (falls Plugin nur DIVs nutzt)
        document.addEventListener('click', () => {
        if (getHero()) setTimeout(scheduleUpdate, 0);
        }, true);

        // Value-Setter des Stoff-Inputs hooken (programmatische Änderungen)
        const hookSetter = () => {
        const inp = document.querySelector(SEL_STOFF);
        if (!inp) return;
        const desc = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
        if (desc && desc.configurable) {
            Object.defineProperty(inp, 'value', {
            get(){ return desc.get.call(this); },
            set(v){ desc.set.call(this, v); log('setter:value erkannt', { v }); scheduleUpdate(); }
            });
            log('Value-Setter gehooked für Stoff-Input');
        }
        };
        hookSetter();

        // Initiales Update
        scheduleUpdate();

        log('Listener gebunden');
    };

    // Start
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => waitForInputs(bindOnce), { once: true });
    } else {
        waitForInputs(bindOnce);
    }
})();
